import React, { useState, useEffect } from 'react'
import { PageButtonsContainer, PaginationBox, PaginationContainer, TotalPages } from './styles'

import { Input } from './components/Input'
import { Button } from './components/Button'

export interface PaginationProps {
  pageNumber: string
  setPageNumber: (pageNumber: string) => void
  totalPages: number
  apiCall?: (pagination: string) => void
  apiCallInterval?: number
  apiCallByFunction?: boolean
  resetPage?: boolean
}

export const Pagination = ({
  pageNumber,
  setPageNumber,
  totalPages,
  apiCall,
  apiCallInterval = 0,
  apiCallByFunction,
  resetPage
}: PaginationProps): JSX.Element => {
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!apiCallByFunction) {
      if (pageNumber !== '' && +pageNumber !== 0 && +pageNumber <= totalPages && apiCall) {
        setTimeout(apiCall, apiCallInterval, pageNumber)
      }
    }
  }, [+pageNumber])

  React.useEffect(() => {
    resetPage && setPageNumber('1')
  }, [resetPage])

  const movePage = (direction: string) => {
    if (direction === 'forward') {
      const forwardPage = `${+pageNumber + 1}`
      setPageNumber(forwardPage)
      handleApiCall(forwardPage)
    } else {
      const backwardPage = `${+pageNumber - 1}`
      setPageNumber(backwardPage)
      handleApiCall(backwardPage)
    }
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    const regex = /^[0-9\b]+$/

    if (regex.test(value)) {
      setPageNumber(value)
      handleApiCall(value)
    } else if (value === '') {
      setPageNumber('')
      handleApiCall('1')
    } else {
      setError(true)
    }
  }

  const handleApiCall = React.useCallback(
    (page: string) => {
      if (apiCallByFunction && apiCall) apiCall(page)
    },
    [apiCall]
  )

  const i =
    +pageNumber === 1
      ? [0, 1, 2, 3, 4]
      : +pageNumber === 2
        ? [-1, 0, 1, 2, 3]
        : totalPages - +pageNumber === 1
          ? [-3, -2, -1, 0, 1]
          : totalPages - +pageNumber === 0
            ? [-4, -3, -2, -1, 0]
            : [-2, -1, 0, 1, 2]

  return (
    <PaginationContainer noAvailable={totalPages <= 0}>
      <PaginationBox>
        <Button pageNumber={pageNumber} totalPages={totalPages} direction="backward" action={movePage} />

        <PageButtonsContainer>
          {i.map(i => {
            if (+pageNumber + i > 0 && +pageNumber + i <= totalPages) {
              return (
                <Input
                  key={+pageNumber + i}
                  value={`${+pageNumber + i}`}
                  maxLength={3}
                  onChange={e => onChange(e)}
                  error={error}
                  isActive={+pageNumber + i === +pageNumber}
                />
              )
            } else {
              return false
            }
          })}
        </PageButtonsContainer>

        <Button pageNumber={pageNumber} totalPages={totalPages} direction="forward" action={movePage} />
      </PaginationBox>
      <TotalPages>de {totalPages}</TotalPages>
    </PaginationContainer>
  )
}
